import React from 'react';
import helper from '../../../../../utils/helper';
import Datagrid from '../../../../UI/Datagrid';

export default (props) => {
  const columns = [
    {
      dataField: 'model',
      text: 'Model',
      sort: true,
      headerStyle: { width: '7%' },
    },
    { dataField: 'serialNo', text: 'Serial Number', sort: true },
    { dataField: 'sensorName', text: 'Name', sort: true },
    { dataField: 'location', text: 'Location', sort: true },
    { dataField: 'typeName', text: 'Type', sort: true },
    { dataField: 'remoteName', text: 'Device', sort: true },
    // {
    //   dataField: 'active',
    //   text: 'Active',
    //   sort: true,
    //   headerStyle: { width: '5%' },
    // },
    // {
    //   dataField: 'alerts',
    //   text: 'Alerts',
    //   sort: true,
    //   headerStyle: { width: '5%' },
    // },
  ];
  const defaultSorted = [
    {
      dataField: 'serialNo',
      order: 'asc',
    },
  ];
  const [sensorIds, setSensorIds] = React.useState([]);
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSensorIds([...sensorIds, row.sensorId]);
    } else {
      setSensorIds(sensorIds.filter((x) => x !== row.sensorId));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.sensorId);
    if (isSelect) {
      setSensorIds((sensorIds) => helper.tableHelper.selectAll(sensorIds, ids));
    } else {
      setSensorIds((sensorIds) =>
        helper.tableHelper.deselectAll(sensorIds, ids),
      );
    }
  };
  const selectRow = {
    mode: 'checkbox',
    selected: sensorIds,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  React.useEffect(() => {
    props.onSelectUnassignedSensors(sensorIds);
  }, [sensorIds]);
  React.useEffect(() => {
    if (props.sensors.isCompleted) {
      setSensorIds([]);
      props.sensorsActions.resetCompleted();
    }
  }, [props.sensors.isCompleted]);
  return (
    <div>
      <h1>{props.t('Unassigned List')}</h1>
      <Datagrid
        datagridProps={{
          keyField: 'sensorId',
          data: props.unassignedSensors,
          columns,
          selectRow,
          defaultSorted,
        }}
        exportProps={{
          fileName: 'UnassignedList',
        }}
      />
    </div>
  );
};
